import http from "../plugins/axios";
import { AxiosError } from "axios";

export interface CompetitionModel {
  bonus: number,
  co_organizer: string,
  competition_status: string,
  description: string,
  end_time: string,
  id: number,
  identifier: string,
  image: string,
  is_new: boolean,
  member_count: number,
  name: string,
  nearly_published: boolean,
  organizer: string,
  published_at: string,
  sponsor: string,
  start_time: string,
  team_count: number
}

export function getCompetitions(): Promise<CompetitionModel[]> {
  return new Promise((resolve, reject) => {
    http
      .get(`/api/competitions/v3atucf9/common_header.json`)
      .then((response) => {
        return resolve(response.data.competitions as CompetitionModel[])
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  })
}